import moment from 'moment'
import { Feature, useFeatureFlag } from '@src/components'
import { Subscription } from '@src/types'

const NEXT_BILLING_CYCLE_TOO_CLOSE_HOURS = 12

export const useCanChangeBillingCycle = (
  subscription?: Pick<
    Subscription,
    'resetBillingCycleAnchorAt' | 'currentPeriodEndAt' | 'cancelAt' | 'paused'
  > & { primaryProduct: { billingDateChangeable: boolean } },
) => {
  const isChangeBillingCycleEnabled = useFeatureFlag(Feature.SubscriptionChangeBillingCycle)

  if (!subscription) {
    return false
  }

  if (isCloseToBillingDate(subscription)) {
    return false
  }

  return (
    (isChangeBillingCycleEnabled &&
      subscription.primaryProduct.billingDateChangeable &&
      !subscription.cancelAt &&
      !subscription.paused) ||
    false
  )
}

const isCloseToBillingDate = (
  subscription: Pick<Subscription, 'resetBillingCycleAnchorAt' | 'currentPeriodEndAt'>,
) => {
  const scheduledBillingDate = moment(
    subscription.resetBillingCycleAnchorAt || subscription.currentPeriodEndAt,
  )

  const nowWithBuffer = moment.max(
    moment().endOf('day'),
    moment().add(NEXT_BILLING_CYCLE_TOO_CLOSE_HOURS, 'hours'),
  )

  if (scheduledBillingDate.isAfter(nowWithBuffer)) {
    return false
  }

  // The current billing cycle period-end or new billing date is too close to safely make changes
  return true
}
